import * as Yup from "yup";
import React from "react";
import {
  TranslatedText,
  getValidationRule,
  getComuniServiti,
} from "../../../helpers/helpers";

import { validEmail, validPhone } from "../../forms/CustomSignUp/validations";
import {
  CaseForms,
  CaseMutationType,
  CaseStepperType,
} from "../../../helpers/enums";
import PrivacyPolicy from "../../common/PrivacyPolicy/PrivacyPolicy";

// Il model definisce la struttura dei dati
// formId è un identificatore del form
// formField contiene la definizione dei singoli campi
const model = {
  formId: CaseForms.FaiUnReclamo,
  formField: {
    comunePuf: {
      name: "comunePuf",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.comune.label" />
      ),
      placeholder: (
        <TranslatedText i18nKey="cases.request_info.fields.placeholder" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      message: true,

      type: "suggestions",
      getItems: (setData) => {
        return getComuniServiti()
          .then((items) => setData(items))
          .catch((error) => {
            console.log("Error fetching comuni serviti: ", error);
            setData([]);
          });
      },
      getSuggestions: (data) => {
        return data;
      },
      filter: (value, data) => {
        return data.filter((item) => {
          return (
            String(item.comune)
              .toLowerCase()
              .indexOf(String(value).toLowerCase()) > -1
          );
        });
      },
      onSelected: (value, data, setFieldValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        if (selected) {
        }
      },
      onBlur: (value, data, setValue) => {
        const [selected] = data.filter(
          (item) =>
            String(item.comune).toLowerCase() === String(value).toLowerCase()
        );
        selected ? setValue(selected.comune) : setValue("");
      },
    },
    indirizzoPuf: {
      name: "indirizzoPuf",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.indirizzo.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    integraClientCode: {
      name: "integraClientCode",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codice_cliente.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      type: "input",
    },
    integraContractCode: {
      name: "integraContractCode",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.codice_contratto.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      type: "input",
    },
    businessName: {
      name: "businessName",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.ragione_sociale.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    serviceClaim: {
      name: "serviceClaim",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.servizio_reclamo.label" />
      ),
      placeholder: "Seleziona il servizio",
      options: [
        { label: <TranslatedText i18nKey="cases.request_info.fields.servizio_reclamo.options.first" />, value: "INDRICO INTREGRATO" },
        {
          label: <TranslatedText i18nKey="cases.request_info.fields.servizio_reclamo.options.second" />,
          value: "ACQUEDOTTO",
        },
        { label: <TranslatedText i18nKey="cases.request_info.fields.servizio_reclamo.options.third" />, value: "FOGNATURE" },
        { label: <TranslatedText i18nKey="cases.request_info.fields.servizio_reclamo.options.fourth" />, value: "DEPURAZIONE" },
      ],
      type: "select",
    },
    selfReading: {
      name: "selfReading",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.autolettura.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      type: "input",
    },
    checkMeter: {
      name: "checkMeter",
      placeholder: "Seleziona il tipo di richiesta",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.richiesta_verifica_misuratore.label" />
      ),
      options: [
        { label: <TranslatedText i18nKey="cases.request_info.fields.richiesta_verifica_misuratore.options.yes" />, value: true },
        { label: <TranslatedText i18nKey="cases.request_info.fields.richiesta_verifica_misuratore.options.no" />, value: false },
      ],
      type: "select",
    },
    landlinePhoneNumber: {
      name: "landlinePhoneNumber",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.telefono.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.telefono.invalid" />
      ),
      type: "input",
    },
    mobilePhoneNumber: {
      name: "mobilePhoneNumber",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.cellulare.label.required" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.cellulare.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    email: {
      name: "email",
      subtitle: <TranslatedText i18nKey="cases.request_info.fields.email.subtitle.required" />,
      label: <TranslatedText i18nKey="cases.request_info.fields.email.label.required" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.email.invalid" />
      ),
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "input",
    },
    pec: {
      name: "pec",
      label: <TranslatedText i18nKey="cases.request_info.fields.pec.label" />,
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      invalidErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.pec.invalid" />
      ),
      type: "input",
    },
    note: {
      name: "note",
      label: (
        <TranslatedText i18nKey="cases.request_info.fields.nome_utente.label" />
      ),
      placeholder: <TranslatedText i18nKey="common.generic.placeholder" />,
      requiredErrorMsg: (
        <TranslatedText i18nKey="cases.request_info.errors.required" />
      ),
      type: "text",
    },
    captcha: {
      name: "captcha",
      label: <TranslatedText i18nKey="cases.richiedi_omaggio.captcha.label" />,
      type: "captcha",
    },
  },
};

const {
  formField: {
    comunePuf,
    indirizzoPuf,
    integraClientCode,
    integraContractCode,
    businessName,
    serviceClaim,
    selfReading,
    checkMeter,
    landlinePhoneNumber,
    mobilePhoneNumber,
    email,
    pec,
    note,
    captcha,
  },
} = model;

// initialValues contiene i valori iniziali del form, ne imposta anche i campi.
// Si può usare per popolare il form eventualmente.
const initialValues = {
  [comunePuf.name]: "",
  [indirizzoPuf.name]: "",
  [integraClientCode.name]: "",
  [integraContractCode.name]: "",
  [businessName.name]: "",
  [serviceClaim.name]: "SELEZIONARE IL SERVIZIO",
  [selfReading.name]: "",
  [checkMeter.name]: "SELEZIONARE",
  [landlinePhoneNumber.name]: "",
  [mobilePhoneNumber.name]: "",
  [email.name]: "",
  [pec.name]: "",
  [note.name]: "",
  [captcha.name]: "",
};

// Per definire il validationSchema si usa un array di shape che indicano gli step.
// L'ordine degli step deve corrispondere a quello in layout.

const getValidationSchema = () => {
  const validationFiscalCode = getValidationRule("fiscalCode");
  console.log(validationFiscalCode);
  return [
    Yup.object().shape({
      [comunePuf.name]: Yup.string().required(comunePuf.requiredErrorMsg),
      [indirizzoPuf.name]: Yup.string().required(indirizzoPuf.requiredErrorMsg),
      [landlinePhoneNumber.name]: Yup.string().matches(validPhone, {
        message: landlinePhoneNumber.invalidErrorMsg,
      }),
      [mobilePhoneNumber.name]: Yup.string().matches(validPhone, {
        message: mobilePhoneNumber.invalidErrorMsg,
      }).required(mobilePhoneNumber.requiredErrorMsg),
      [email.name]: Yup.string().matches(validEmail, {
        message: email.invalidErrorMsg,
      }).required(email.requiredErrorMsg),
      [pec.name]: Yup.string().matches(validEmail, {
        message: pec.invalidErrorMsg,
      }),
      [businessName.name]: Yup.string().required(businessName.requiredErrorMsg),
      [note.name]: Yup.string().required(note.requiredErrorMsg),
      [checkMeter.name]: Yup.string().required(checkMeter.requiredErrorMsg),
      [serviceClaim.name]: Yup.string().required(serviceClaim.requiredErrorMsg),
      [captcha.name]: Yup.string().required(note.requiredErrorMsg),
    }),
  ];
};

// Il layout contiene informazioni di testo e di distribuzione sulle griglie
const getLayout = (privacyLink, privacyCtaLabel) => {
  return ([
    {
      chapter: true,
      chapterName: "Form semplice 1",
      title: "",
      fields: [
        {
          fieldName: null,

          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.request_info.titles.title1" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: comunePuf.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: indirizzoPuf.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: integraClientCode.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: integraContractCode.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.request_info.titles.title2" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: businessName.name,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: serviceClaim.name,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: selfReading.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: checkMeter.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: landlinePhoneNumber.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: mobilePhoneNumber.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: email.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: pec.name,
          grid: {
            xs: 12,
            md: 6,
          },
        },
        {
          fieldName: null,
          text: (
            <h2 className="case-step-title">
              <TranslatedText i18nKey="cases.request_info.titles.title3" />
            </h2>
          ),
          grid: {
            xs: 12,
          },
        },

        {
          fieldName: note.name,
          grid: {
            xs: 12,
          },
        },
        {
          fieldName: captcha.name,
          grid: {
            xs: 12,
          },
        },
      ],
      content: (
        <div>
          <p>
            <PrivacyPolicy privacyLink={privacyLink} privacyCtaLabel={privacyCtaLabel}/>
          </p>
          <p>
            <TranslatedText i18nKey="cases.info.legal2" />
          </p>
        </div>
      ),
    },
  ])
}

// Contiene dettagli sul case form
const formDetails = {
  title: <TranslatedText i18nKey="cases.fai_un_reclamo.title" />,
  description: null,
  summary: false,
  stepper: CaseStepperType.None,

  helpText: null,
  successText: (
    <div>
      <p>
        <TranslatedText i18nKey="cases.request_info.success_text" />
      </p>
    </div>
  ),
};

const mutation = {
  type: CaseMutationType.Simple,
};

const main = (excludeSteps, counter, signDigital, webviewPopup, webviewRedirectPopup, buttonMatricolaContatoreCase, privacyLink, privacyCtaLabel) => {
  const layout = getLayout(privacyLink, privacyCtaLabel);
  return {
    model,
    validationSchema: getValidationSchema(),
    initialValues,
    layout,
    formDetails,
    mutation,
  };
};

export default main;
